var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zt-button',{staticClass:"go-back",attrs:{"color":"dark-400","icon":"angle-left","text":"","data-vs-button":"go_back"},on:{"click":_vm.goBack}},[_vm._v("\n  "+_vm._s(_vm.$t('message.customEmails.go_back_btn'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }